var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CompressResolver } from "./index";
export default class NoCompressionResolver extends CompressResolver {
    static typeName() {
        return "NoCompression";
    }
    // eslint-disable-next-line class-methods-use-this
    compress(messageEvent) {
        return __awaiter(this, void 0, void 0, function* () {
            return JSON.stringify(messageEvent);
        });
    }
    // eslint-disable-next-line class-methods-use-this
    decompress(messageEvent) {
        return __awaiter(this, void 0, void 0, function* () {
            return JSON.parse(messageEvent.data);
        });
    }
}
//# sourceMappingURL=noCompression.compressionResolver.js.map